import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DeleteSectionButton from '../../../DeleteSectionButton';
import Configurations from './Configurations';
import Content from './Content';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  contentNoHeader: {
    display: 'flex',              
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '90vh',          
    textAlign: 'center',
  }
}));

export default function PromotionalBanner({ data, showDeleteButton }) {
  const headerData = useSelector(state => state.ThemeReducer.settings.find(a => a.key === 'header'))
  const headerIsVisible = headerData.options?.isVisible
  const classes = useStyles();

  if (headerIsVisible === false) {
    return (
      <main className={classes.contentNoHeader}>
        <FontAwesomeIcon icon={['fas', 'info']} size={'lg'} />
        <p>Ative o cabeçalho para poder configurar a faixa promocional</p>
      </main>
    )
  } else {
    return (
      <main className={classes.content}>
        <Configurations data={data} />
        {data.options.isVisible && (
          <Content data={data} />
        )}
        {showDeleteButton && <DeleteSectionButton />}
      </main>
    );
  }
}